// Connectivity debounce timings, kept in a dependency-free module so both the
// runtime hook (useConnectivityMonitor) and e2e tests can import them. The hook
// can't be imported into Playwright specs directly — it pulls in NetInfo, a
// native module that fails to load in Node — so these live here on their own.

// How long offline must persist before the app reports it (avoids flashing the
// "You are offline" banner on brief blips).
export const OFFLINE_DEBOUNCE_MS = 10_000

// How long online must persist before the app clears the offline state.
export const ONLINE_DEBOUNCE_MS = 2_000

// Timeout for the server health check that confirms an offline transition.
export const HEALTH_TIMEOUT_MS = 5_000
